import { createEvent } from 'effector';

export const setPromoShortCode = createEvent<string>();
